<template>
  <div>
    <extended-radio-group v-model="radio_option"
                          :disabled="false"
                          :options="radio_options"
                          style="margin-bottom: 2em"/>
    <b-table :current-page="currentPage"
             :fields="fields"
             :items="visible_rows"
             :per-page="localPerPage"
             head-variant="light"
             hover
             striped>
      <template v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="visible_rows"
                         :fields="fields"
                         :not-include-key="['actions','ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: localPerPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(actions)="row">
        <base-icon-button-delete title="Unbook"
                                 @click="remove_row(row)"/>
      </template>
    </b-table>
    <b-table-footer v-model="loading"
                    :current-page="currentPage"
                    :data-length="visible_rows.length"
                    :per-page="localPerPage"
                    @change-page="change_page">
      <template v-slot>
        <base-per-page-input v-model="localPerPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import BaseIconButtonDelete from '@/components/base-components/base-icons/BaseIconButtonDelete';
  import BTableFooter from '@/components/BTableFooter';
  import ExtendedRadioGroup from '@/components/ExtendedRadioGroup';
  import moment from 'moment';
  import ProposalFilter from '@/components/ProposalFilter';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';

  export default {
    name: 'cryoem_dates_exclude_list',
    components: {
      BaseIconButtonDelete,
      ProposalFilter,
      BTableFooter,
      ExtendedRadioGroup,
      BaseColumnOrdinalNumber,
      BasePerPageInput,
    },
    props: {
      config: {
        type: Object,
        default: () => ({}),
      },
      fields: {
        type: Array,
        default: () => [],
      },
      perPage: {
        type: Number,
        default: 10,
      },
    },
    data() {
      return {
        id: 1,
        loading: false,
        currentPage: 1,
        localPerPage: this.perPage,
        all_rows: [],
        visible_rows: [],
        radio_options: [
          {
            text: 'Show all dates',
            value: 'all_dates',
            buttonVariant: 'outline-info',
          },
          {
            text: 'Show current dates',
            value: 'current_dates',
            buttonVariant: 'outline-info',
          },
        ],
        radio_option: 'current_dates',
      };
    },
    computed: {
      today_date() {
        return moment(new Date()).format('YYYY-MM-DD');
      },
    },
    methods: {
      change_page(val) {
        this.currentPage = val;
      },
      remove_row(row) {
        const data = {
          name: row.item.title.replace(' ', '_'),
          dates: [{ start: row.item.start, end: row.item.end }],
        };
        this.axios.put('/config/cryoem-calendar/dates', data)
          .then((response) => {
            if (response.data.msg) {
              this.$emit('config-changed');
              this.$notify({ type: 'success', title: response.data.msg });
            } else {
              this.$notify({ type: 'error', title: response.data.err });
            }
          });
      },
      set_all_rows(data) {
        const conf_list = [];
        Object.entries(data).forEach(([key, val]) => {
          if (key !== 'weekdays') {
            val.forEach(((el) => {
              if ((this.radio_option === 'current_dates' && el.end >= this.today_date)
                || this.radio_option === 'all_dates') {
                conf_list.push({
                  title: key.replace('_', ' '),
                  start: el.start,
                  end: el.end,
                });
              }
            }));
          }
        });

        this.$set(this, 'all_rows', conf_list);
      },
    },
    watch: {
      // this watcher is needed by the proposal-filter
      all_rows() {
        this.$set(this, 'visible_rows', this.all_rows);
        this.$emit('setup-proposal', this.visible_rows);
      },
      config() {
        return this.set_all_rows(this.config);
      },
      radio_option() {
        this.set_all_rows(this.config);
      },
    },
  };
</script>

<style scoped>
  input {
    border: none;
  }
</style>
